import { Injectable } from '@angular/core';
import { AuthService } from '@core/auth/auth.service';
import { WorkSpace, WorkSpaceAdapter } from '@core/models/workspace';
import { BehaviorSubject, filter } from 'rxjs';
import { OrganisationService } from './organisation.service';
import { Organisation } from '@core/models/organisation/organisation.model';
import { OrganisationListItem } from '@core/models/organisation/organisation-list-item.model';
import { FeatureService } from './feature.service';
import { FeatureType } from '@core/models/features/feature.model';


@Injectable({
providedIn: 'root'
})

export class WorkSpaceService {

userWorkSpace$: BehaviorSubject<WorkSpace|null> = new BehaviorSubject<WorkSpace|null>(null);
orgWorkSpaces$: BehaviorSubject<WorkSpace[]|null> = new BehaviorSubject<WorkSpace[]|null>(null);
currentOrgWorkSpace$: BehaviorSubject<WorkSpace|null> = new BehaviorSubject<WorkSpace|null>(null);

private orgWorkSpaces:WorkSpace[] = [];
private userId:string = "";

constructor(private authService:AuthService, private organisationService:OrganisationService, private workSpaceAdapter:WorkSpaceAdapter, private fs:FeatureService) {
  this.loadOrgWorkSpaces();
  authService.isAuthenticated().subscribe(value =>{
    if(value){
      this.userId = authService.User.id;
    }else{
      this.userId = ''
    }
  });

  this.organisationService.currentOrganisation$.pipe(filter((o): o is Organisation => o !== null)).subscribe(org => {
    if(this.organisationService.isSwitchingToOrg){
      this.organisationService.isSwitchingToOrg = false;
      const newWs = this.workSpaceAdapter.adapt(org, true, true);
      this.setActiveWorkSpace(newWs);
    }
  });
}

 init(){
   if(this.userId){
    this.setUserWorkSpaceActive(!this.selectedOrgWorkSpace);
  }
}

loadOrgWorkSpaces(){
  this.organisationService.currentOrganisationList$.pipe(filter((x): x is OrganisationListItem[] => x !== null)).subscribe((orgs:OrganisationListItem[]) => {
    this.orgWorkSpaces = orgs.filter(x =>  this.fs.checkRoleFeatureAcces(x.role,FeatureType.WORKSPACE_ACCESS)).map(org => this.workSpaceAdapter.adapt(org, false,false));
    this.orgWorkSpaces$.next(this.orgWorkSpaces);
  })
 }

 setActiveWorkSpace(ws:WorkSpace){
  if(this.userId){
    if(this.selectedOrgWorkSpace){
      this.selectedOrgWorkSpace.active = false;
      this.selectedOrgWorkSpace.selected = false;
    }

    ws.active = true;
    ws.selected = true;
    localStorage.setItem("ows_sl_"+this.userId,JSON.stringify(ws));
    this.currentOrgWorkSpace$.next(ws);
    this.setUserWorkSpaceActive(false);
  }
 }

 setUserWorkSpaceActive(active:boolean){
   if(this.userId){
    const u = this.authService.User;
    const uws:WorkSpace = { id:u.id, name: u.firstName + ' ' + u.lastName, image: u.image, isOrganisationWorkSpace:false, active:active, selected: true,role:"admin"};
    localStorage.setItem("ws_sl_"+this.userId,JSON.stringify(uws));
    this.userWorkSpace$.next(uws);

    if(active && this.selectedOrgWorkSpace){
      const ws = this.selectedOrgWorkSpace;
      ws.active = false;
      localStorage.setItem("ows_sl_"+this.userId,JSON.stringify(ws));
      this.currentOrgWorkSpace$.next(ws);
    }
   }
 }

 get currentWorkSpace(){
  const body =  JSON.parse(localStorage.getItem("ws_sl_"+this.userId) as string);
  if(body){
    const ws =  body as WorkSpace;
    return ws;
  }
  return null;
 }

 get selectedOrgWorkSpace(){
  const body =  JSON.parse(localStorage.getItem("ows_sl_"+this.userId) as string);
  if(body){
    const ws =  body as WorkSpace;
    return ws;
  }
  return null;
 }

 clear(){
  this.currentOrgWorkSpace$.next(null);
  this.userWorkSpace$.next(null);
  this.orgWorkSpaces$.next(null);
 }

 // Forgets the given organisation as selected workspace (e.g. after losing access to it); the menu then
 // falls back to the first workspace of the reloaded organisation list
 resetOrgWorkSpace(orgId:string){
  if(this.selectedOrgWorkSpace?.id == orgId){
    this.deleteLocalStorageOWS();
    this.currentOrgWorkSpace$.next(null);
  }
  this.setUserWorkSpaceActive(true);
 }

 deleteLocalStorageOWS(){
  localStorage.removeItem("ows_sl_"+this.userId);
 }


 updateCurrentOrgWorkSpace(org:Organisation){

  let ws = this.orgWorkSpaces.find(x => x.id == org.id);
  if(ws){
    Object.assign(ws,this.workSpaceAdapter.adapt(org, true,true));
    this.setActiveWorkSpace(ws);
 }
}

}
